export default function TripCheckoutBookOrHoldService() {
    Object.assign(this, {

    });
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-checkout-book-or-hold/trip-checkout-book-or-hold-service.js